/**
 * Streak HUD element (V4, S-10 HUD / S-22) — the counter + tier flame.
 * Pure render of server state (SM §0): count/tier arrive via GET /killstreak
 * and the §4.3 pushes; nothing is computed here. Exported for the deck HUD
 * (V7 integration) and used by the /killstreak screen.
 */
import { KillstreakBadge, type KillstreakTier } from "../../design/index.js";

export function tierForCount(tierReached: number): KillstreakTier | null {
  if (tierReached >= 15) return "beyond";
  if (tierReached >= 10) return 10;
  if (tierReached >= 7) return 7;
  if (tierReached >= 5) return 5;
  if (tierReached >= 3) return 3;
  return null;
}

export function StreakHud({ count, tierReached }: { count: number; tierReached: number }) {
  if (count <= 0) return null; // state cosmetics die with the streak (EC-03)
  const tier = tierForCount(tierReached);
  return (
    <div className="streak-hud" aria-label={`killstreak ${count}`}>
      {tier ? (
        <KillstreakBadge tier={tier} count={count} />
      ) : (
        <span className="streak-hud__count">
          <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor" aria-hidden="true">
            <path d="M12 2s1 3.2-1.5 6C8.2 10.5 7 12.2 7 14.5A5 5 0 0 0 12 19.5a5 5 0 0 0 5-5c0-1.6-.6-2.8-1.4-4 0 1.2-.7 2-1.6 2.3.5-1.8.3-4.3-1-6.3C12.4 4.7 12 2 12 2z" />
          </svg>
          ×{count}
        </span>
      )}
    </div>
  );
}
